import { fetchAuthSession } from 'aws-amplify/auth';
import { reportSessionExpired } from '../auth/sessionExpiry';

// Builds Authorization headers from the current Cognito access token
export const getAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString();

    if (!token) {
      // The refresh token itself has expired: sign out and say so (#284).
      reportSessionExpired();
      throw new Error('No authentication token found in session');
    }

    return {
      Authorization: `Bearer ${token}`,
    };
  } catch (error) {
    console.error('Error getting auth headers:', error);
    throw error;
  }
};

// Best-effort variant for public endpoints: the viewer's Authorization header
// when a session exists, `{}` otherwise. Never throws and never logs — an
// anonymous visitor is the normal case, not an error. With no stored tokens
// this is a local cookie read (no identity pool is configured, so no network).
export const getOptionalAuthHeaders = async (): Promise<Record<string, string>> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
};
